import { Pressure } from './pressure'
import { blockLabels, charLabels } from './reader'

const pageInfoElement = document.getElementById('page-info')
const blocksContainer = document.getElementById('blocks-container')
const SESSION_DETAILS = JSON.parse(pageInfoElement.getAttribute('data-session'))
Object.detach = function (o) {
  return JSON.parse(JSON.stringify(o))
}
function tempUuid () {
  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, function (c) {
    const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
function htmlEscape (string) {
  // If null or undefined, return empty string
  if (string == null) return ''
  if (typeof string.toString !== 'function') return
  return string.toString().replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
/**
 * Returns an item from or an entire array of ancestor elements
 * @param {HTMLElement} element The element to get the node tree from
 * @param {number} index The number of nodes to travel up (or down) the tree
 * @param {boolean} topDown Whether to return a top-down tree that ends with
 * the element instead of starting with the element
 * @returns Either the array (if no index is specified) or the node at the
 * specified index of the node tree
 */
function nodeTree (element, index, topDown) {
  const tree = []
  let target = element
  while (target && target !== document.documentElement) {
    tree.push(target)
    target = target.parentNode
  }
  if (topDown) tree.reverse()
  if (index == null) return tree
  return tree[index] || null
}
function getBlockJSON (element) {
  const jsonAttribute = element.dataset.json
  return jsonAttribute ? JSON.parse(element.dataset.json) : null
}
/**
 * Regenerates the block content from the provided info, but not any child blocks
 * @param {HTMLElement} blockEl The wrapper element of the block
 * @param {Object} json The data to use when re-rendering the block
 * on how to render the block in HTML
 */
function rerenderBlock (blockEl, json) {
  const info = jsonToHtml(json, null, true)

  blockEl.dataset.id = info.id
  blockEl.dataset.json = info.data

  const tempElement = document.createElement('div')
  tempElement.innerHTML = info.innerHTML

  // Replace the HTML of only the main block content
  // rather than also replacing inner blocks
  blockEl.querySelector('.block-content').innerHTML =
    tempElement.querySelector('.block-content').innerHTML

  if (typeof BlockParameter === 'undefined') return
  blockEl.querySelectorAll('.param-bubble').forEach(parameter => {
    // Re-initiate dragging on all parameters
    BlockParameter.create(parameter)
  })
}

/** @todo Move all classes and enumerators into separate file */

function isFalseScript (container) {
  isFalse = false
  if (container && container.previousElementSibling) {
    // If it is a false script (is the second collapsible)
    isFalse = container.previousElementSibling.classList.contains('collapsible')
  }
  return isFalse
}
function blockOuterHTML (blockInfo, isPseudoFrame) {
  return `<div class="${isPseudoFrame ? 'pseudo-frame ' : ''}${blockInfo.classList}"
    data-json="${htmlEscape(blockInfo.data)}"
    data-id="${blockInfo.id}"
    data-group="${blockInfo.sortGroup}"
  >${blockInfo.innerHTML}</div>`
}

const ParameterRenderer = {
  textObjImage: '<img src="/images/characters/text-object.svg" width="36"/>',
  hsvToRgb: function (str) {
    const arr = str.replace(/.*\(|\)/g, '').split(',')
    const h = Math.max((Number(arr[0])) / 360, 0)
    const s = Math.max((Number(arr[1]) % 101) / 100, 0)
    const v = Math.max((Number(arr[2]) % 101) / 100, 0)
    let r, g, b
    const i = Math.floor(h * 6)
    const f = h * 6 - i; const p = v * (1 - s)
    const q = v * (1 - f * s); const t = v * (1 - (1 - f) * s)
    switch (i % 6) {
      // eslint-disable-next-line
      case 0: r = v, g = t, b = p; break; case 1: r = q, g = v, b = p; break; case 2: r = p, g = v, b = t; break; case 3: r = p, g = q, b = v; break; case 4: r = t, g = p, b = v; break; case 5: r = v, g = p, b = q; break
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)]
  },
  /**
   * Returns the variable name given its ID
   * @param {string} id The ID of the variable
   * @returns {string} The name of the variable
   */
  getVariable: function (id) {
    const variable = ProjectVariable.get(id)
    if (!variable) return '<span style="color:red;">unknown</span>'
    return htmlEscape(variable.name)
  },
  /**
   * Returns the trait name given its ID
   * @param {string} id The ID of the variable
   * @returns {string} The name of the trait
   */
  getTrait: function (id) {
    const trait = ProjectTrait.get(id)
    if (!trait) return '<span style="color:red;">unknown</span>'
    const name = (blockLabels[trait.HSTraitTypeKey] || [])[0]
    return htmlEscape(name)
  },
  /**
   * Returns the styled image tag that corresponds to the stage object type
   * @param {number} type The Image/Object type in the parameter
   * @returns The styled image tag that corresponds to that object type
   */
  objectImage: function (type, customObjectID) {
    const imgRegex = new RegExp(
      // Undefined when still loading
      `<img src=(""|"undefined|"blob:${
        htmlEscape(location.origin.replace(/\./g, '\\.'))
      }|"/images/characters).*?/>`
    )
    const parameter = { datum: { type, customObject: customObjectID } }
    return this.render(parameter).match(imgRegex)[0]
  },
  /**
   * Returns whether the value is a valid HSB color
   * @param {string} value The parameter value to test
   * @returns {boolean} Whether the value is a color
   */
  isColor: function (value) {
    return /HSB\(\s?(-?[0-9]*?\.?[0-9]*?,?\s?){3}\)$/.test(value)
  },
  /**
   * Returns the object's image and type used in object references
   * @param {Object} object The JSON data of the object
   * @returns Returns the HTML for the object's label
   */
  objectLabel: function (object) {
    const name = object && object.name ? htmlEscape(object.name) : 'Object'
    const contents = `${
    object.type === 1
      ? ParameterRenderer.textObjImage
      : ParameterRenderer.objectImage(object.type, object.customObjectID)
    }<span data-object-id="${htmlEscape(object.objectID)}">${name}</span>`
    return contents
  },
  /**
   * Renders an event parameter
   * @param {string} eventParamID The ID of the event parameter to render
   * @returns {string} The HTML for the event parameter
   */
  eventParameter: function (eventParamID) {
    const eventParam = ProjectEventParameter.get(eventParamID) || {}
    eventParam.type = eventParam.type || eventParam.blockType
    if (eventParam.type !== 8000) {
      const eventName = eventParam.description || blockLabels[eventParam.type] || ''
      return `<span>${htmlEscape(eventName)}</span>`
    }
    const obj = ProjectStageObject.get(eventParam.objectID)
    if (obj) {
      return ParameterRenderer.objectLabel(obj)
    }
    return `<span data-object-id=${htmlEscape(eventParam.objectID)}>Object</span>`
  },
  /**
   * Renders a sound parameter, inserting the proper icon
   * @param {string} value The value of the sound parameter
   * @returns {string} The rendered icon for the sound with the matching value
   */
  classicSound: function (value) {
    value = htmlEscape(value)
    return `<i class="hs-sound hs-${value.replace(/\s/g, '_')}"></i>`
  },
  /**
   * Renders a rhythm based on the provided parameter value
   * @param {string} value The value of the rhythm parameter
   * @returns {string} The rendered icon and name of the rhythm
   */
  rhythm: function (value) {
    const name = rhythmNames[value] || ''
    return `<i class="hs-rhythm hs-${name.toLowerCase().replace(/\s/g, '-')}"></i>` +
      `<span>${name}</span>`
  },
  /**
   * Renders a music note based on the provided parameter value
   * @param {string} value The value of the music note parameter
   * @returns {string} The rendered icon of the music note
   */
  musicNote: function (value) {
    value = htmlEscape(value)
    return `<i class="hs-note hs-note${value}"></i>`
  },
  /**
   * Renders an instrument icon based on the provided parameter value
   * @param {string} value The value of the instrument parameter
   * @returns {string} The rendered icon for the instrument
   */
  instrument: function (value) {
    value = htmlEscape(value)
    return `<i class="hs-instrument hs-${value.replace(/\s/g, '')}"></i>`
  },
  /**
   * Renders a trail cap icon based on the provided parameter value
   * @param {string} value The value of the trail cap parameter
   * @returns {string} The rendered icon for the trail cap
   */
  trailCap: function (value) {
    value = htmlEscape(value)
    return `<i class="hs-trail-cap hs-trail-${value}"></i>`
  },
  /**
   * Renders a variable or trait in the legacy ID reference format
   * @param {id} variableID The ID of the trait or variable to render
   * @returns {string} The rendered trait or variable text
   */
  legacyVariable: function (variableID) {
    let operatorClass = 'val'
    const objectRef = hsProject.objects.find(obj => {
      const variable = ProjectVariable.get(variableID) || {}
      const trait = ProjectTrait.get(variableID) || {}

      return obj.objectID === variable.objectIdString ||
        obj.objectID === variable.HSObjectIDString ||
        obj.objectID === trait.HSTraitObjectIDKey
    })

    let objectLabel = ''
    const traitExists = ParameterRenderer.getTrait(variableID) !==
      '<span style="color:red;">unknown</span>'
    operatorClass = traitExists ? 'otr' : 'val'
    if (typeof objectRef === 'object') {
      const image = objectRef.type === 1
        ? ParameterRenderer.textObjImage
        : ParameterRenderer.objectImage(objectRef.type)
      objectLabel = `${image}<span>${htmlEscape(objectRef.name)}</span>`
    }
    const name = traitExists
      ? ParameterRenderer.getTrait(variableID)
      : ParameterRenderer.getVariable(variableID)

    const content = `${objectLabel}<span>${name}</span>`
    const paramType = traitExists ? 'trait' : 'var'
    return ParameterRenderer.wrapOperator(operatorClass, content, paramType)
  },
  /**
   * Renders the image from the parameter datum trait
   * @param {Object} datum The datum inside of the parameter
   * @returns {string} The HTML code to display the image data
   */
  imageData: function (datum) {
    const dataType = datum.type
    if (dataType === 1) {
      const content = '<span>Text</span>' +
      `<div class="param-bubble" data-type="TextOnly"><span>${
        htmlEscape(datum.text.replace(/\n(.|\n)*/g, ''))
      }</span></div>`
      return ParameterRenderer.wrapOperator('cm', content, 'image')
    } else {
      const customObjectId = datum.customObjectID || datum.customObject
      let cObj // Declare custom object variable
      let imagePath
      // If param data type is 2000 (custom image), search through the custom objects array
      // and set the custom object to the first result
      if (dataType === 2000) {
        cObj = hsProject.customObjects.find(a => a.id === customObjectId)
        imagePath = ProjectCustomImage.objectURLs[cObj ? cObj.fileName : '']
      } else {
        const label = (charLabels[dataType] || '').toLowerCase()
        const characterImage = `/images/characters/${label}.svg`
        imagePath = characterImage
      }

      const content = `<img src="${htmlEscape(imagePath)}" width="36" />`

      return ParameterRenderer.wrapOperator('fw cm', content, 'image')
    }
  },
  /**
   * Renders a trait inside a parameter
   * @param {Object} parameter The parameter
   * @returns {string} The HTML used to display the trait
   */
  trait: function (parameter) {
    const type = parameter.datum.HSTraitTypeKey
    const traitObjType = parameter.datum.HSTraitObjectParameterTypeKey
    const label = blockLabels[traitObjType] || ['']
    let [labelContent, wrap] = label
    labelContent = labelContent ? `<span>${labelContent}</span>` : ''
    if (traitObjType === 8000) {
      const obj = ProjectStageObject.get(parameter.datum.HSTraitObjectIDKey)
      labelContent = ParameterRenderer.objectLabel(obj || { name: 'Object' })
    }
    const objectLabel = wrap ? ParameterRenderer.wrapParam(50, labelContent) : labelContent
    const content = `${objectLabel}<span>${blockLabels[type]}</span>`
    return ParameterRenderer.wrapOperator('otr', content, 'trait')
  },
  /**
   * Renders a variable inside of a parameter
   * @param {Object} parameter The parameter
   * @returns {string} The HTML used to display the variable
   */
  variable: function (parameter) {
    const dataType = parameter.datum.type
    const label = blockLabels[dataType] || []
    let [labelContent, wrap] = label
    labelContent = labelContent ? `<span>${labelContent}</span>` : ''
    if (dataType === 8000) {
      // Object Variable
      const obj = ProjectStageObject.get(parameter.datum.object)
      labelContent = ParameterRenderer.objectLabel(obj)
    } else if (dataType === 8009) {
      // Local Variable
      const content = `<span>${htmlEscape(parameter.datum.name)}</span>`
      return ParameterRenderer.wrapOperator('val', content, 'var')
    }
    const objectLabel = wrap ? ParameterRenderer.wrapParam(50, labelContent) : labelContent
    // All other variables
    const content = `${objectLabel}<span>${
      ParameterRenderer.getVariable(parameter.datum.variable)
    }</span>`
    return ParameterRenderer.wrapOperator('val', content, 'var')
  },
  /**
   * Renders an operator inside of a parameter
   * @param {Object} parameter The parameter
   * @returns {string} The HTML used to display the operator
   */
  standardOperator: function (parameter) {
    const dataType = parameter.datum.type
    const isBlock = dataType < 1000
    const isConditional = dataType >= 1000 && dataType < 2000
    const isMathOperator = dataType >= 4000 && dataType < 5000
    const isColorOperator = dataType >= 5000 && dataType < 6000
    const isRuleOperator = dataType >= 7000 && dataType < 8000
    const isTextOperator = dataType >= 9000 && dataType < 10000
    function operatorClassName () {
      if (isBlock || isConditional) return 'cnd cm'
      if (isRuleOperator) return 'cm'
      if (isTextOperator) return 'looks'
      return 'math cm'
    }
    function operatorType () {
      if (isRuleOperator) return 'rule'
      if (isTextOperator) return 'text'
      if (isColorOperator) return 'color'
      if (isMathOperator) return 'math'
      if (isConditional) return 'conditional'
      return 'block'
    }
    function operatorDescription () {
      if (isRuleOperator) return ''
      const labels = blockLabels[dataType] || []
      return labels[1] !== undefined ? labels[1] : parameter.datum.description || ''
    }
    // Blocks, Math, Conditionals, Game Rules, Text Operators
    if (isBlock || isConditional || isMathOperator ||
    isColorOperator || isRuleOperator || isTextOperator) {
      const innerContents = (parameter.datum.params || []).map((param, index) => {
        const paramLabel = blockLabels[dataType] && blockLabels[dataType][index + 2]
        const paramString = paramLabel !== undefined ? paramLabel : param.key || ''
        const wrappedParamKey = paramString ? `<span>${htmlEscape(paramString)}</span>` : ''
        return wrappedParamKey + ParameterRenderer.renderWrapped(param)
      }).join('')
      const ruleName = isRuleOperator ? blockLabels[dataType][1] : ''
      const content = `<span class="operator-name">${
        htmlEscape(operatorDescription())
      }</span>${innerContents}${
        ruleName ? `<span>${ruleName}</span>` : ''
      }`
      return ParameterRenderer.wrapOperator(operatorClassName(), content, operatorType())
    }
  },
  /**
   * Renders the contents of a parameter
   * @param {Object} parameter The parameter
   * @returns {string} The HTML used to display the contents of the parameter
   */
  render: function (parameter) {
    if (!parameter.datum) {
      if (parameter.type !== 50 && typeof parameter.value !== 'string') {
        return '<span></span>'
      }
      const isColorParam = ParameterRenderer.isColor(parameter.value)
      if (parameter.type === 44 && isColorParam && !parameter.variable) {
        return {
          parent: `<div class="param-bubble fw" data-type="${paramTypes[44]}"
            style="background-color:rgb(${
              htmlEscape(ParameterRenderer.hsvToRgb(parameter.value))
            })"></div>`
        }
      } else {
        switch (parameter.type) {
          case 50: {
            // Event Parameter
            return ParameterRenderer.eventParameter(parameter.variable)
          }
          case 51: {
            // Sound Parameter
            return ParameterRenderer.classicSound(parameter.value)
          }
          case 59: {
            // Rhythm
            return ParameterRenderer.rhythm(parameter.value)
          }
          case 60: {
            // Music Note
            return ParameterRenderer.musicNote(parameter.value)
          }
          case 61: {
            // Instrument
            return ParameterRenderer.instrument(parameter.value)
          }
          case 63: {
            // Trail Cap
            return ParameterRenderer.trailCap(parameter.value)
          }
          default:
            if (parameter.variable) {
              return ParameterRenderer.legacyVariable(parameter.variable)
            }
            return `<span data-default="${htmlEscape(parameter.defaultValue)}">${
              htmlEscape(parameter.value.replace(/\n(.|\n)*/g, ''))
            }</span>`
        }
      }
    }
    const dataType = parameter.datum.type
    // Products
    if (dataType === 8008) {
      const content = `<span>${ParameterRenderer.getVariable(parameter.datum.variable)}</span>`
      return ParameterRenderer.wrapOperator('prod', content, 'product')
    }
    // Traits
    if (parameter.datum.HSTraitTypeKey >= 2000 && parameter.datum.HSTraitTypeKey < 4000) {
      return ParameterRenderer.trait(parameter)
    }
    // Variables
    if (dataType === 8000 || (dataType >= 8003 && dataType < 8010)) {
      return ParameterRenderer.variable(parameter)
    }
    // Images (no block class)
    if (!/operator/i.test(parameter.datum.block_class)) {
      return ParameterRenderer.imageData(parameter.datum)
    }
    // Random Color
    if (dataType === 5000) {
      return ParameterRenderer.wrapOperator('rcol', '', 'color')
    }

    return ParameterRenderer.standardOperator(parameter) ||
      '<span style="color:#0CF">unrecognized format</span>'
  },
  /**
   * Renders a parameter's contents and wraps it inside of the parent bubble
   * @param {Object} parameter The parameter to render
   * @returns The parameter, wrapped inside of a parameter bubble
   */
  renderWrapped: function (parameter) {
    const rendered = ParameterRenderer.render(parameter)
    if (rendered.parent) return rendered.parent
    return ParameterRenderer.wrapParam(parameter.type, rendered)
  },
  /**
   * Wraps the provided content inside of a parameter bubble
   * @param {number} type The type of parameter
   * @param {string} html The inner content of the parameter
   * @returns The parameter, wrapped inside of a parameter bubble
   */
  wrapParam: function (type, html) {
    const typeName = paramTypes[type]
    return `<div class="param-bubble" data-type="${typeName}">${html}</div>`
  },
  /**
   * Wraps the provided operator content inside of a container
   * @param {string} classList The CSS operator class list
   * @param {string} html The HTML content inside the operator
   * @param {string} type The category of operator, i.e. math
   * @returns The operator, wrapped inside of an operator container
   */
  wrapOperator: function (classList, html, type) {
    return `<div class="operator ${classList}" data-type="${type || ''}">${html}</div>`
  }
}

function fillEmptyScripts (block) {
  if (block.controlScript && !block.controlScript.abilityID) {
    block.controlScript.abilityID = new ProjectAbility().abilityID
  }
  if (block.controlFalseScript && !block.controlFalseScript.abilityID) {
    block.controlFalseScript.abilityID = new ProjectAbility().abilityID
  }
}

let oldProjAlerted = false
let nestedUuidList = []
function jsonToHtml (block, isNested, keepClosed, openChildBlocks) {
  isNested = isNested || false
  keepClosed = keepClosed || false

  let collapsible = false
  let sortGroup = 'blocks'
  let blockParent = activeBlock
  let myBlockType
  if (block.scripts) {
    if (!oldProjAlerted) {
      console.error(new TypeError('The block renderer cannot fully render old project formats'))
    }
    oldProjAlerted = true
  }
  let controlScript = block.controlScript

  // Convert ID references to respective object, rule,
  // custom rule, or custom rule instance
  if (typeof block === 'string') {
    block = ProjectRule.get(block) ||
      (hsProject.customRules && ProjectCustomRule.get(block)) ||
      (hsProject.customRuleInstances && ProjectCustomRuleInstance.get(block)) ||
      ProjectStageObject.get(block) || block
  }
  let parameters = block.parameters
  // Set data of objects
  if (block.xPosition != null) {
    collapsible = true
    parameters = [{
      type: 54 // Same as Set Image
    }]
    // If an object type exists, provide image data
    if (block.type != null) {
      parameters[0].datum = {
        type: block.type,
        customObject: block.customObjectID,
        text: block.text
      }
    }
  }
  // Change the container type for rules, custom rules, objects, and scenes
  if (block.customRuleID) {
    collapsible = true
    sortGroup = 'rules'
  }
  if (block.ruleBlockType && !block.type) block.type = block.ruleBlockType
  if (block.rules) {
    collapsible = true
    sortGroup = 'rules'
  } else if (block.objects) {
    // Scenes
    collapsible = true
    sortGroup = 'objects'
  } else if (block.abilityID && !controlScript) {
    controlScript = { abilityID: block.abilityID }
    collapsible = true
  }

  if (/control/i.test(block.block_class)) {
    collapsible = true
  }

  let myScripts
  if (activeBlock) {
    const myData = JSON.parse(activeBlock.dataset.json)
    function getScriptsExpression (data) {
      const controlScript = data.controlScript
      if (!controlScript) return /$.^/
      const falseScript = data.controlFalseScript || { abilityID: '' }
      const cases = [
        controlScript.abilityID,
        falseScript.abilityID
      ].filter(x => !!x)
      return new RegExp('^(' + cases.join('|') + ')$', 'm')
    }
    if (myData) myScripts = getScriptsExpression(myData)
  }
  let parentGroup = blockParent ? blockParent.dataset.group : ''
  while (blockParent && parentGroup !== 'rules') {
    // Check if a block is nested
    const isFalse = isFalseScript(blockParent.parentNode)
    blockParent = (blockParent.parentNode || { parentNode: null }).parentNode
    const parentData = blockParent.dataset.json
    if (!parentData) blockParent = null
    else {
      parentGroup = blockParent.dataset.group
      const parsedData = JSON.parse(parentData)
      const reachedOuterParent = !blockParent || parentGroup === 'rules'
      const parentAbility = parsedData[isFalse ? 'controlFalseScript' : 'controlScript']
      const abilityID = (parentAbility && parentAbility.abilityID) || parsedData.abilityID
      if (!reachedOuterParent && myScripts.test(abilityID)) isNested = true
    }
  }

  if (JSON.stringify(block) === '{}') {
    return { innerHTML: '' }
  }
  if (!isNested) nestedUuidList = []
  let elmClass = 'block-wrapper'
  if (collapsible) {
    function getElementClass (block) {
      const labels = blockLabels[block.type] || []
      switch (true) {
        case block.xPosition != null:
          return 'obj'
        case labels[0] === 'draw':
          return 'draw'
        case block.type === 123:
          return 'abl'
        case block.type === 6000:
          return 'rule'
        case !!block.rules || !!block.customRuleID:
          return 'crule'
        case !!block.objects:
          return 'scn'
        default: return ''
      }
    }
    elmClass += ` collapsible-container ${getElementClass(block)}`
  }
  function getClassLabel (block) {
    switch (true) {
      case !!block.variable: return ['val']
      case block.xPosition != null: return ['obj']
      case !!blockLabels[block.type]: return blockLabels[block.type]
      case !!block.rules || !!block.customRuleID: return ['crule']
      case !!block.objects: return ['scn']
      default: return ['']
    }
  }
  const labels = getClassLabel(block)
  let paramString = ''
  for (let i = 0; i < (parameters || []).length; i++) {
    const parameter = parameters[i]
    const renderedParam = ParameterRenderer.renderWrapped(parameter)
    paramString += `<div class="text-wrapper"><span>${
      htmlEscape(labels[i + 2] || parameter.key || '')
      }</span></div>` + renderedParam
  }
  function getBlockName (block) {
    if (block.type === 123 && !block.rules) {
      const { controlScript } = block
      const abilityID = controlScript ? controlScript.abilityID : block.abilityID
      if (!abilityID) return ''
      const ability = hsProject.abilities.find(a => a.abilityID === abilityID)
      return (ability ? ability.name : block.description) || ''
    }
    if (block.customRuleID) {
      const customRule = hsProject.customRules.find(cr => cr.id === block.customRuleID) || {}
      return customRule.name || ''
    }
    // If type is old custom rule, object, or scene
    if (['crule', 'obj', 'scn'].includes(labels[0])) return block.name || ''
    return labels[1] || ''
  }
  const editingEnabled = typeof EditorContainer !== 'undefined'
  const editableIfNeeded = editingEnabled && (block.objects || block.xPosition != null)
    ? 'contenteditable spellcheck="false"'
    : ''
  const editSceneBtnIfNeeded = editingEnabled && sortGroup === 'objects'
    ? '<div class="edit-scene-btn"><i class="hs-icon hs-expand"></i></div>'
    : ''
  let innerHTML = `<div class="block ${labels[0]}">
    <div class="block-content"><span class="block-name" ${editableIfNeeded}>${
      htmlEscape(getBlockName(block))
    }</span>${paramString}</div>${editSceneBtnIfNeeded}
    <div class="bl-handle"><i class="hs-icon hs-drag-handle"></i></div>
  </div>`

  function addDisabledIfNeeded (script, classList) {
    const disabled = nestedUuidList.includes(script)
    return classList.replace('collapsible-container', disabled ? 'disabled' : '')
  }
  if (collapsible) {
    let nestedHTML = '<div class="collapsible">'
    const trueScript = htmlEscape((controlScript || {}).abilityID || '')
    const falseScript = htmlEscape((block.controlFalseScript || {}).abilityID || '')
    const nestedAbilityID = trueScript
    let addedToHtml = false
    if (block.customRuleID) {
      if (!keepClosed) {
        const customRule = hsProject.customRules.find(cr => cr.id === block.customRuleID)
        if (customRule.abilityID) {
          const ability = ProjectAbility.get(customRule.abilityID, true)
          const blockInfo = jsonToHtml(ability, true, false)
          nestedHTML += blockOuterHTML(blockInfo, true)
        }
        customRule.rules.forEach(ruleID => {
          const rule = ProjectRule.get(ruleID) || ProjectCustomRuleInstance.get(ruleID)
          if (!rule) return
          const blockInfo = jsonToHtml(rule, true, !openChildBlocks, openChildBlocks)
          nestedHTML += blockOuterHTML(blockInfo, false)
        })
      } else {
        elmClass = addDisabledIfNeeded(trueScript, elmClass)
      }
    } else if (!trueScript && block.rules) {
      // Handle Objects and Custom Rules
      addedToHtml = true
      if (!keepClosed) {
        if (block.abilityID) {
          const ability = ProjectAbility.get(block.abilityID, true)
          const blockInfo = jsonToHtml(ability, true, false)
          nestedHTML += blockOuterHTML(blockInfo, true)
        }
        (Object.keys(block.rules || {}) || []).forEach(rule => {
          r = block.rules[rule]
          nestedUuidList.push(r)
          const blockInfo = jsonToHtml(r, true, !openChildBlocks, openChildBlocks)
          nestedHTML += blockOuterHTML(blockInfo, false)
        })
      } else {
        elmClass = addDisabledIfNeeded(trueScript, elmClass)
      }
    } else if (!trueScript && block.objects) {
      // Handle objects inside of scenes
      addedToHtml = true
      if (!keepClosed) {
        (block.objects || []).forEach((o) => {
          nestedUuidList.push(o)
          const blockInfo = jsonToHtml(o, true, !openChildBlocks, openChildBlocks)
          nestedHTML += blockOuterHTML(blockInfo, false)
        })
      } else {
        elmClass = addDisabledIfNeeded(trueScript, elmClass)
      }
    }
    const a = ProjectAbility.get(trueScript)
    if (a) {
      if (a && nestedUuidList.indexOf(trueScript) === -1) addedToHtml = true
      if (!keepClosed && a && nestedUuidList.indexOf(trueScript) === -1) {
        nestedUuidList.push(a.abilityID)
        a.blocks.forEach((block, index) => {
          fillEmptyScripts(block)
          const blockInfo = jsonToHtml(block, true, block.type === 123)
          // Less than ideal, but this structure for iterating blocks
          // is temporary and will be changed soon
          blockInfo.id = htmlEscape(blockInfo.id || `${a.abilityID}_b${index}`)
          if (blockInfo.innerHTML) nestedHTML += blockOuterHTML(blockInfo, false)
        })
      } else {
        elmClass = addDisabledIfNeeded(trueScript, elmClass)
      }
    }
    if (!addedToHtml && (trueScript || block.rules) && block && keepClosed) {
      elmClass = addDisabledIfNeeded(trueScript, elmClass)
    }
    addedToHtml = false
    innerHTML = innerHTML.replace('<div class="block-content">',
      '<div class="openbtn"></div><div class="block-content">') + nestedHTML + '</div>'
    if (block.type === 124) {
      let nestedHTML = `<div class="collapsible" data-ability="${falseScript}">`
      const a = ProjectAbility.get(falseScript)
      if (a) {
        if (!keepClosed && a && nestedUuidList.indexOf(falseScript) === -1) {
          addedToHtml = true
          nestedUuidList.push(a.abilityID);
          (Object.keys(a.blocks) || []).forEach((k) => {
            const b = a.blocks[k] || {}
            const blockInfo = jsonToHtml(b, true, (b.type === 123))
            nestedHTML += blockOuterHTML(blockInfo, false)
          })
        } else {
          elmClass = elmClass.replace('collapsible-container ', '')
        }
      }
      innerHTML = innerHTML + nestedHTML + '</div>'
    }
    if (!addedToHtml && falseScript && block && keepClosed) {
      elmClass = addDisabledIfNeeded(trueScript, elmClass)
    }
    if (keepClosed) {
      innerHTML = innerHTML.replace(/<div class="collapsible"[^>]*><\/div>/g, '')
    } else if (nestedAbilityID) {
      innerHTML = innerHTML.replace(
        /<(div class="collapsible")>/,
        `<$1 data-ability="${htmlEscape(nestedAbilityID)}">`
      )
    }
  }
  if (block.rules || block.objects || block.type === 6000) {
    delete block.block_class
  }
  block = Object.detach(block)
  myScripts = null
  // If controlScript is in block attributes, not "if there are nested blocks"
  if (block.controlScript) {
    const scriptList = [
      controlScript.abilityID,
      block.controlFalseScript ? block.controlFalseScript.abilityID : null
    ].filter(x => !!x)
    myScripts = htmlEscape(`(${scriptList.join('|')})`)
  }
  const blockId = htmlEscape(myScripts || block.id || block.objectID || '')
  return {
    id: blockId,
    classList: elmClass.trim().replace(/\s+/, ' '),
    data: JSON.stringify(block),
    innerHTML,
    sortGroup,
    focusType: myBlockType,
    scripts: myScripts
  }
}

const hsProject = {}
function closeMatchingBlocks (activeBlock) {
  if (activeBlock.dataset.id) {
    const matcher = new RegExp(`^${activeBlock.dataset.id}$`)
    const matchingOpenBlocks = [...blocksContainer.querySelectorAll('.block-wrapper')]
      .filter(block => matcher.test(block.dataset.id)) // same ability ID
      .filter(block => block !== activeBlock) // is not current block
      .filter(block => block.matches('.collapsible-container')) // is open
    matchingOpenBlocks.forEach(b => expandBlock({ target: b.querySelector('.openbtn') }))
  }
  /** @todo change .crule to .custom-rule */
  if (activeBlock.matches('.crule')) {
    const data = getBlockJSON(activeBlock)
    const matchingBlocks = ProjectCustomRule.matchingEditorBlocks(data.customRuleID)
    matchingBlocks.forEach(block => {
      if (!block.matches('.collapsible-container')) return
      expandBlock({ target: block.querySelector('.openbtn') })
    })
  }
}
/**
 * Opens or closes a block when the user clicks the expand arrow
 * @param {PointerEvent} event The pointer event
 */
function expandBlock (event, forceOpen) {
  if (typeof BlockParameter !== 'undefined') {
    // Deselect parameters because we're focusing the block
    // Deselection happens before expansion
    BlockParameter.deselectAll()
  }
  const parentBlock = event.target.parentNode.parentNode
  const hasDomInside = Boolean(parentBlock.childElementCount > 1)
  if (hasDomInside) {
    parentBlock.classList.toggle('collapsible-container')
    parentBlock.querySelectorAll('div.collapsible').remove()
  } else {
    // If there is no child container, refresh the block and load what's inside.
    activeBlock = parentBlock
    closeMatchingBlocks(activeBlock)
    appendChildBlocks(true, activeBlock.dataset.json, forceOpen)
  }
  if (typeof EditorContainer !== 'undefined') {
    EditorContainer.cleanup()
  }
  if (typeof BlockParameter !== 'undefined') {
    // Cleanup happens after expansion
    BlockParameter.cleanup()
  }
}
/**
 * Adds expand/collapse functionality to a block
 * @param {HTMLElement} parent The parent block element, which contains the JSON
 */
function addBlockFunctions (parent) {
  parent.querySelectorAll('*:not(.disabled) > div.block .openbtn').forEach(element => {
    // Return if listener already exists
    if (Pressure.instances.find(i => i.element === element)) return
    element.onpointerup = () => {}
    const threshold = 300
    Pressure.create(element, {
      change: e => {
        const isClosed = !nodeTree(element, 2).matches('.collapsible-container')
        element.classList.toggle('large', isClosed && e.factor === 1)
      },
      end: e => {
        if (e.time < threshold) return expandBlock(e.event)
        expandBlock(e.event, true)
      },
      timeThreshold: threshold
    })
  })
  parent.querySelectorAll('.param-bubble').forEach(parameter => {
    if (typeof BlockParameter === 'undefined') return
    // Don't make parameters draggable for the keyboard
    if (!blocksContainer.contains(parameter)) return
    BlockParameter.create(parameter)
  })
  parent.addEventListener('error', e => {
    if (e.target.tagName !== 'IMG') return
    // Remove Image if it fails to load so that we don't show the browser's placeholder
    if (ProjectCustomImage.loaded) return e.target.remove()
    e.target.src = '/images/loading_apple.gif'
    window.addEventListener('project-images-loaded', () => {
      const parentBlock = nodeTree(e.target).find(node => node.matches('.block-wrapper'))
      if (!parentBlock) return
      // Deselect because we are re-rendering the block
      if (typeof BlockParameter !== 'undefined') BlockParameter.deselectAll()
      rerenderBlock(parentBlock, getBlockJSON(parentBlock))
    }, { once: true })
  }, { capture: true })
  parent.querySelectorAll('.edit-scene-btn').forEach(button => {
    button.addEventListener('click', e => {
      const sceneName = button.parentNode.querySelector('.block-name').innerText
      SceneEditor.show(sceneName)
    })
  })
}

function initEmbedOptions (project) {
  if (typeof EmbeddedPlayer === 'undefined') return
  if (project.can_edit) EmbeddedPlayer.originalProject = project
  EmbeddedPlayer.projectId = project.uuid
  EmbeddedPlayer.updateExitOptions(project)
}

function render () {
  Object.assign(hsProject, JSON.parse(pageInfoElement.dataset.project))
  initEmbedOptions(hsProject)
  // Old projects render objects at top level because scenes don't exist
  globalThis.globalScope = hsProject.scenes ? 'scenes' : 'objects'
  ProjectUpdater.run()
  ProjectCustomImage.createObjectURLs()
  const data = hsProject.scenes || hsProject.objects || []
  // Data = Data Array, Top Container Type (e.g. Rules, Objects)
  if (typeof EditorContainer !== 'undefined') {
    EditorContainer.create(blocksContainer)
  }
  data.forEach(function (item) {
    const blockElm = document.createElement('div')
    const keepClosed = [
      item.type === 123,
      typeof item === 'string',
      item.xPosition != null,
      item.objects && data.length > 1
    ].includes(true)
    const blockInfo = jsonToHtml(item, undefined, keepClosed)
    blockElm.classList.value = blockInfo.classList
    blockElm.dataset.json = blockInfo.data
    blockElm.dataset.group = blockInfo.sortGroup
    if (blockInfo.id) blockElm.dataset.id = blockInfo.id
    blockElm.innerHTML = blockInfo.innerHTML
    blocksContainer.appendChild(blockElm)
    if (typeof EditorContainer !== 'undefined') {
      EditorContainer.fromParent(blockElm)
    }
  })
  if (typeof renderAdvanced === 'function') renderAdvanced()
  addBlockFunctions(document)
}
let activeBlock
function appendChildBlocks (forceOpen, data, openChildBlocks) {
  forceOpen = forceOpen || false
  data = data || '{}'
  // Open the block if forced to open or is already open
  const keepClosed = !(forceOpen || activeBlock.classList.contains('collapsible-container'))
  const info = jsonToHtml(JSON.parse(data), undefined, keepClosed, openChildBlocks)
  activeBlock.innerHTML = info.innerHTML
  activeBlock.setAttribute('class', info.classList)
  if (info.id) activeBlock.dataset.id = info.id
  if (typeof EditorContainer !== 'undefined') {
    EditorContainer.fromParent(activeBlock)
  }
  addBlockFunctions(activeBlock)
  activeBlock = null
}

try {
  window.addEventListener('project-load', render, { once: true })
} catch (e) {
  document.querySelector('h1').innerText = 'Loading Error'
  console.error(e)
  console.error(new Error('Unable to Load Project'))
}
window.addEventListener('load', () => {
  if (typeof messageHandler !== 'undefined' && self !== top) return
  // Project is view only or parent frame doesn't exist, so it must be done loading
  const customLoadEvent = new CustomEvent('project-load')
  window.dispatchEvent(customLoadEvent)
}, { once: true })

const viewOnlyMessage = document.querySelector('.viewonly-message')
if (viewOnlyMessage && !SESSION_DETAILS.isLoggedIn) {
  viewOnlyMessage.querySelector('.regular-screen').innerText = 'Log in to edit projects!'
  viewOnlyMessage.querySelector('.small-screen').innerText = 'Log in to edit'
}

const globals = {
  hsProject,
  pageInfoElement,
  blocksContainer,
  SESSION_DETAILS,
  tempUuid,
  htmlEscape,
  nodeTree,
  getBlockJSON,
  rerenderBlock,
  isFalseScript,
  blockOuterHTML,
  ParameterRenderer,
  fillEmptyScripts,
  jsonToHtml,
  closeMatchingBlocks,
  expandBlock,
  addBlockFunctions,
  initEmbedOptions,
  render,
  appendChildBlocks
}
Object.assign(globalThis, globals)
export {
  hsProject,
  pageInfoElement,
  blocksContainer,
  SESSION_DETAILS,
  tempUuid,
  htmlEscape,
  nodeTree,
  getBlockJSON,
  rerenderBlock,
  isFalseScript,
  blockOuterHTML,
  ParameterRenderer,
  fillEmptyScripts,
  jsonToHtml,
  closeMatchingBlocks,
  expandBlock,
  addBlockFunctions,
  initEmbedOptions,
  render,
  appendChildBlocks
}
